"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Preview = require("../Preview");
var _prismCore = require("prismjs/components/prism-core");
var _style = _interopRequireDefault(require("./style.css"));
var _prettify = _interopRequireDefault(require("../prettify.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var QueryView = function QueryView(props) {
  var query;
  try {
    query = (0, _Preview.getQuery)(props.settings, _prettify["default"]);
  } catch (e) {
    query = (0, _Preview.getQuery)(props.settings);
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].query,
    dangerouslySetInnerHTML: {
      __html: (0, _prismCore.highlight)(query, _prismCore.languages.graphql)
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-default",
    onClick: props.closeModal
  }, "Close"));
};
QueryView.propTypes = {
  settings: _propTypes["default"].object,
  closeModal: _propTypes["default"].func
};
var _default = exports["default"] = QueryView;